import React, { Component } from 'react';
import './LoadingApp.css';

import Loading from '../ui/Loading.js';

class LoadingApp extends Component {

  render() {

    return (
      <div className = "LoadingApp">
        <Loading/>
      </div>
    );

  }

}

export default LoadingApp;
